/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiCustomListsDtoCustomListItemFieldValueDto } from './WebApiCustomListsDtoCustomListItemFieldValueDto';
import {
    WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSON,
    WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSONTyped,
    WebApiCustomListsDtoCustomListItemFieldValueDtoToJSON,
} from './WebApiCustomListsDtoCustomListItemFieldValueDto';

/**
 * 
 * @export
 * @interface WebApiCustomListsDtoUpdateCustomListItemDto
 */
export interface WebApiCustomListsDtoUpdateCustomListItemDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoUpdateCustomListItemDto
     */
    id?: number;
    /**
     * 
     * @type {Array<WebApiCustomListsDtoCustomListItemFieldValueDto>}
     * @memberof WebApiCustomListsDtoUpdateCustomListItemDto
     */
    fieldValues?: Array<WebApiCustomListsDtoCustomListItemFieldValueDto> | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoUpdateCustomListItemDto
     */
    updatedBy?: number | null;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoUpdateCustomListItemDto interface.
 */
export function instanceOfWebApiCustomListsDtoUpdateCustomListItemDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoUpdateCustomListItemDtoFromJSON(json: any): WebApiCustomListsDtoUpdateCustomListItemDto {
    return WebApiCustomListsDtoUpdateCustomListItemDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoUpdateCustomListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoUpdateCustomListItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'fieldValues': !exists(json, 'fieldValues') ? undefined : (json['fieldValues'] === null ? null : (json['fieldValues'] as Array<any>).map(WebApiCustomListsDtoCustomListItemFieldValueDtoFromJSON)),
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function WebApiCustomListsDtoUpdateCustomListItemDtoToJSON(value?: WebApiCustomListsDtoUpdateCustomListItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'fieldValues': value.fieldValues === undefined ? undefined : (value.fieldValues === null ? null : (value.fieldValues as Array<any>).map(WebApiCustomListsDtoCustomListItemFieldValueDtoToJSON)),
        'updatedBy': value.updatedBy,
    };
}

